import { useThreads } from "@/hooks/api/threads/useThreads";
import { Threads } from "@/models/Thread";
import { makeStyles } from "@fluentui/react-components";
import * as React from "react";
import { ThreadGroup } from "./ThreadGroup";

export const ThreadHistory: React.FC = () => {
  const { data: threads, isLoading } = useThreads();

  const threadGroups: Array<{ id: string; heading: string; threads: Threads; }> = [
    { id: "1", heading: "過去", threads: threads! },
  ];

  const classes = useStyles();
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <div className={classes.threadGroups}>
      {threadGroups.map((group) => {
        return <ThreadGroup key={group.id} heading={group.heading} threads={group.threads}></ThreadGroup>;
      })}
    </div>
  );
};

const useStyles = makeStyles({
  threadGroups: {
    "display": "flex",
    "flexDirection": "column",
    "gap": "16px",
    "flex": "1 1 auto", // Allow it to grow and shrink, with auto basis
    "overflowY": "auto", // Enable vertical scrolling
    "minHeight": "0", // Critical for scroll to work in a flex container
    "paddingBottom": "16px", // Add some padding at the bottom for better UX
  },
});
